import { useQuery } from "@tanstack/react-query";
import { Typography } from "antd";
import { journalsQueries } from "@/entities/journal";
import { TableInfo, TableInfoType } from "@/features/table-info";
import { useCoordinator } from "@/shared/lib/hooks";
import { fallbackString } from "@/shared/utils";

interface IJournalsSupervisionOfficialProps {
  titleData: any;
}

export const JournalsSupervisionOfficial = ({
  titleData,
}: IJournalsSupervisionOfficialProps) => {
  const { titleId } = useCoordinator();

  const { data: journalDetailsData, isPending: isLoading } = useQuery(
    journalsQueries.getTitleDetails({
      mainJournalId: titleData?.mainJournal?.mainJournalId || "",
      registrationInfoId:
        titleData?.mainJournal?.titleJournal?.registrationInfoId || "",
      titleId,
    }),
  );

  const registrationInfo = journalDetailsData?.registrationInfo;

  const document =
    journalDetailsData?.buildingInfo?.supervisionInfo
      ?.supervisoryAuthorityOfficial?.administrativeDocument;

  const officialInfo =
    journalDetailsData?.buildingInfo?.supervisionInfo
      ?.supervisoryAuthorityOfficial?.supervisoryAuthorityOfficialInfo;

  const fullName = [
    officialInfo?.lastName,
    officialInfo?.firstName,
    officialInfo?.middleName,
  ]
    .filter(Boolean)
    .join(" ");

  const formattedDate = document?.date
    ? new Date(document.date).toLocaleDateString("ru-RU")
    : "";

  const docName = [document?.name, document?.number, formattedDate]
    .filter(Boolean)
    .join(", ");

  const tableData: TableInfoType[] = [
    {
      id: 1,
      title: "ФИО",
      info: fallbackString(fullName),
    },
    {
      id: 2,
      title: "Должность",
      info: fallbackString(officialInfo?.position),
    },
    {
      id: 3,
      title: "Распорядительный документ, подтверждающий полномочия",
      info: fallbackString(docName),
    },
  ];

  if (!registrationInfo) {
    return (
      <div className="table-container">
        <Typography.Title level={4}>
          Должностное лицо органа государственного строительного надзора
        </Typography.Title>
        <div className="journal-empty-text">
          Сведения не присланы
        </div>
      </div>
    );
  }

  return (
    <TableInfo
      tabs={tableData}
      name="Должностное лицо органа государственного строительного надзора"
      editionalName="Информация о представителе"
      id="journals-supervision-official"
      isLoading={isLoading}
    />
  );
};
